import { setupStyledForm } from "./styled-form";
import { setupAjaxForm } from "./ajax-form";
import { createValidator } from "./validation/validator";
import delegate from "delegate-it";

let initialized = false;

export const toggleSubmit = (form) => {
  const submitButton =
    form.querySelector('[type="submit"]') || document.querySelector(`[type="submit"][form="${form.id}"]`);

  if (submitButton) {
    submitButton.disabled = !submitButton.disabled;
    submitButton.classList.toggle("is-loading");
  }
};

export const showFormMessages = (form, messages = [], success, autoHide = true) => {
  const holder = form.querySelector(".form-messages");

  if (!holder || messages.length === 0) {
    return;
  }

  holder.replaceChildren();
  holder.style.display = "block";

  messages.forEach((message) => {
    const fragment = document.createRange().createContextualFragment(message.message);
    const isOnlyText = Array.from(fragment.childNodes).every(
      (node) => node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE && node.tagName === "BR"),
    );

    if (isOnlyText) {
      const p = document.createElement("p");
      p.appendChild(fragment);
      holder.appendChild(p);
    } else {
      holder.appendChild(fragment);
    }
  });

  if (success) {
    holder.classList.remove("form-message-error");
  } else {
    holder.classList.add("form-message-error");
  }

  if (autoHide) {
    setTimeout(() => {
      holder.style.display = "none";
    }, 5000);
  }
};

const setupValidateOnlyForm = (form) => {
  const validator = createValidator(form);

  form.addEventListener("submit", (e) => {
    const result = validator.validateForm();

    if (!result.isValid) {
      e.preventDefault();
    }
  });
};

const setupForm = (form) => {
  if (form.dataset.formInit === "true") {
    return;
  }

  const embedCourtUrlField = form.querySelector('input[name="CourtURL"]');
  if (embedCourtUrlField && typeof window._mfhcembedBuildPublicUrl === "function") {
    embedCourtUrlField.value = window._mfhcembedBuildPublicUrl(window.location.href);
  }

  if (form.dataset.formStyled) {
    setupStyledForm(form);
  }

  if (form.dataset.formValidate && !form.dataset.formAjax) {
    setupValidateOnlyForm(form);
  }

  if (form.dataset.formAjax) {
    setupAjaxForm(form);
  }

  form.setAttribute("data-form-init", "true");
};

const handleModalForms = (e) => {
  e.detail.modalEl.querySelectorAll("form").forEach((form) => {
    setupForm(form);
  });
};

export const setupForms = () => {
  document.querySelectorAll(".app-form").forEach((form) => {
    setupForm(form);
  });
};

export default {
  init: () => {
    if (initialized) {
      setupForms();
      return;
    }

    initialized = true;
    setupForms();

    delegate("html", "modal:populate", handleModalForms);
  },
};
